<template>
  <div class="profile-pic">
    <smd-profile-img v-if="hasProfileURL"
                     :size="'s'"
                     :image="profilePic"/>
    <smd-profile-img-placeholder v-if="!hasProfileURL"
                                 :text="name"/>
  </div>
</template>

<script>
  export default {
    name: "MessageProfilePic",
    props: {
      profilePic: {type: String, required: false},
      name: {type: String, required: false},
    },
    computed: {
      hasProfileURL() {
        return this.profilePic !== null;
      },
    }
  }
</script>

<style lang="scss">
  .profile-pic {
    align-self: flex-end;
    @include space-me($prop: margin, $r: s);
  }
</style>